import {RegionTypes} from '../enums';

export const REGION_LABELS_MAP = {
  [RegionTypes.ctprvn]: '시/도',
  [RegionTypes.sig]: '시/군/구',
  [RegionTypes.emd]: '읍/면/동',
};

export const REGION_LABELS = Object.values(REGION_LABELS_MAP);
